<template>
    <div class="form">
        <a-card :title="c_title">
            <v-gobackbutton slot="extra">返回</v-gobackbutton>
            <a-form-model :model="appData" ref="ruleForm" :rules="rules" :layout="formItemLayout" :label-col="labelCol"
                :wrapper-col="wrapperCol">
                <a-form-model-item ref="appcode" label="应用编码" prop="appcode" v-if="!is_app_auth">
                    <span class="form_span" style="font-size:16px;font-weight:bold;" @blur="
                    () => {
                        $refs.appcode.onFieldBlur();
                    }
                    ">{{appData.appcode ? appData.appcode :'空' }}</span>
                </a-form-model-item>

                <a-form-model-item ref="appcode" label="应用编码" prop="appcode" v-if="is_app_auth">
                    <span class="form_span" style="font-size:16px;font-weight:bold;" @blur="
                    () => {
                        $refs.appcode.onFieldBlur();
                    }
                    ">{{appData.appcode ? appData.appcode :'空' }}</span>
                    <a-button type="primary" style="margin-left:20px;" @click="handleSelectAppcode2"
                        v-if="type == 'addappriskconfig'">
                        点击选择
                    </a-button>
                </a-form-model-item>

                <a-form-model-item ref="authappcode" label="授权应用编码" prop="authappcode"
                    v-if="appData.isoverall != 1 && !is_app_auth">
                    <span class="form_span" style="font-size:16px;font-weight:bold;" @blur="
                    () => {
                        $refs.authappcode.onFieldBlur();
                    }
                    ">{{appData.authappcode ? appData.authappcode :'空' }}</span>
                    <a-button type="primary" style="margin-left:20px;" @click="handleSelectAppcode"
                        v-if="type == 'addriskconfig'">
                        点击选择
                    </a-button>
                </a-form-model-item>

                <a-form-model-item ref="domain" label="领域" prop="domain" v-if="!is_app_auth">
                    <span style="font-size:16px;font-weight:bold;">{{domainName[appData.domain]}}</span>
                </a-form-model-item>
                <a-form-model-item ref="servicekey" label="服务编码" prop="servicekey" v-if="!is_app_auth">
                    <span class="form_span" style="font-size:16px;font-weight:bold;" @blur="
                    () => {
                        $refs.servicekey.onFieldBlur();
                    }
                    ">{{appData.servicekey ? appData.servicekey :'空' }}</span>
                </a-form-model-item>
                <a-form-model-item ref="serviceconfig" label="服务配置" prop="serviceconfig" v-if="!is_app_auth">
                    <span class="form_span" style="font-size:16px;font-weight:bold;" @blur="
                    () => {
                        $refs.serviceconfig.onFieldBlur();
                    }
                    ">{{appData.serviceconfig ? appData.serviceconfig :'空' }}</span>
                </a-form-model-item>


                <a-form-model-item ref="authflag" label="开启流控" prop="authflag">
                    <a-radio-group v-model="appData.authflag" button-style="solid">
                        <a-radio-button value="0">
                            关闭
                        </a-radio-button>
                        <a-radio-button value="1">
                            开启
                        </a-radio-button>
                    </a-radio-group>

                </a-form-model-item>


                <a-form-model-item ref="isoverall" label="是否全局" prop="isoverall" v-if="!is_app_auth">
                    <a-radio-group v-model="appData.isoverall" button-style="solid" @change="handleoverallchange"
                        v-if="type == 'addriskconfig'">
                        <a-radio-button value="0">
                            否
                        </a-radio-button>
                        <a-radio-button value="1">
                            是
                        </a-radio-button>
                    </a-radio-group>
                    <span class="form_span" style="font-size:16px;font-weight:bold;"
                        v-else>{{appData.isoverall == '1' ? '是' : '否'}}</span>

                </a-form-model-item>


                <a-form-model-item ref="coresize" label="核心线程数" prop="coresize">
                    <a-input-number v-model="configData.coresize"
                        v-decorator="['input-number', { initialValue: configData.coresize }]" :min="1" />
                    <a-popover title="coresize">
                        <template slot="content">
                            <p>核心线程数</p>
                        </template>
                        <a-icon type="question-circle" style="margin-left:20px;font-size:16px;" />
                    </a-popover>
                </a-form-model-item>

                <a-form-model-item ref="requestVolumeThreshold" label="跳闸最小请求数量" prop="requestVolumeThreshold">
                    <a-input-number v-model="configData.requestVolumeThreshold"
                        v-decorator="['input-number', { initialValue: configData.requestVolumeThreshold }]" :min="1" />
                    <a-popover title="requestVolumeThreshold">
                        <template slot="content">
                            <p>此属性设置将使断路器打开的滑动窗口中的最小请求数量</p>
                            <p>例如，如果值是20，那么如果在滑动窗口中只接收到19个请求(比如一个10秒的窗口)，即使所有19个请求都失败了，断路器也不会打开。</p>
                            <p>建议保持默认值，如果部分接口不能容忍默认阈值可以单独配置</p>
                        </template>
                        <a-icon type="question-circle" style="margin-left:20px;font-size:16px;" />
                    </a-popover>
                </a-form-model-item>

                <a-form-model-item ref="errorThresholdPercentage" label="错误半分比阀值" prop="errorThresholdPercentage">
                    <a-input-number v-model="configData.errorThresholdPercentage"
                        v-decorator="['input-number', { initialValue: configData.errorThresholdPercentage }]"
                        :min="1" />
                    <a-popover title="errorThresholdPercentage">
                        <template slot="content">
                            <p>此属性设置一个错误百分比，当请求错误率超过设定值，断路器就会打开。</p>
                            <p>建议保持默认值。</p>
                        </template>
                        <a-icon type="question-circle" style="margin-left:20px;font-size:16px;" />
                    </a-popover>
                </a-form-model-item>

                <a-form-model-item ref="sleepWindowInMilliseconds" label="跳闸休眠时间（ms）" prop="sleepWindowInMilliseconds">
                    <a-input-number v-model="configData.sleepWindowInMilliseconds"
                        v-decorator="['input-number', { initialValue: configData.sleepWindowInMilliseconds }]"
                        :min="1" />
                    <a-popover title="sleepWindowInMilliseconds">
                        <template slot="content">
                            <p>此属性设置断路器打开后拒绝请求的时间量，每隔一段时间(sleepWindowInMilliseconds，单位是毫秒)允许再次尝试(也就是放行一个请求)确定是否应该关闭断路器。
                            </p>
                            <p>建议保持默认值</p>
                        </template>
                        <a-icon type="question-circle" style="margin-left:20px;font-size:16px;" />
                    </a-popover>
                </a-form-model-item>

                <a-form-model-item ref="timeoutInMilliseconds" label="超时时间上限（ms）" prop="timeoutInMilliseconds">
                    <a-input-number v-model="configData.timeoutInMilliseconds"
                        v-decorator="['input-number', { initialValue: configData.timeoutInMilliseconds }]" :min="1" />
                    <a-popover title="timeoutInMilliseconds">
                        <template slot="content">
                            <p>HystrixCommand执行时候超时的最大上限，单位是毫秒，如果命令执行耗时超过此时间值那么会进入降级逻辑。这个配置生效的前提是hystrix.command.default.execution.timeout.enabled或者hystrix.command.[HystrixCommandKey].execution.timeout.enabled为true。
                            </p>
                            <p>保持选用默认值</p>
                        </template>
                        <a-icon type="question-circle" style="margin-left:20px;font-size:16px;" />
                    </a-popover>
                </a-form-model-item>
                <a-form-item :wrapper-col="{ span: 10,offset:5}">
                    <a-button type="dashed" style="width: 60%" @click="add">
                        <a-icon type="plus" /> 添加配置
                    </a-button>
                    <ConfigModal :dynaimacState="dynaimacState" @onModalHide="onNewConfig"></ConfigModal>
                </a-form-item>
                <a-form-model-item v-for="(k, index) in dynamicConfig" :key="index" :label="k.name">
                    <a-input-number v-model="k.value" :min="1" />
                    <a-icon class="dynamic-delete-button" type="minus-circle-o" @click="() => remove(k)" />
                </a-form-model-item>
                <a-form-model-item :wrapper-col="{ span: 10, offset: 8 }" v-show="is_vue_task">
                    <a-button type="primary" @click="handleOk">
                        保存
                    </a-button>
                    <a-button style="margin-left: 10px;" @click="handleCancel">
                        取消
                    </a-button>
                </a-form-model-item>
            </a-form-model>
            <AppSelecter :modalState="modalState" @onModalHide="onAppselecterHide"></AppSelecter>
        </a-card>
    </div>

</template>
<script>
import AppSelecter from '@/components/AppSelecter'
import ConfigModal from './configmodal'

const defaultConfig =  {
    coresize:10,
    requestVolumeThreshold:20,
    errorThresholdPercentage:50,
    sleepWindowInMilliseconds:5000,
    timeoutInMilliseconds:5000,
};

const realKey = {
    coresize:"hystrix.threadpool.%s.coreSize",
    requestVolumeThreshold:"hystrix.command.%s.circuitBreaker.requestVolumeThreshold",
    errorThresholdPercentage:"hystrix.command.%s.circuitBreaker.errorThresholdPercentage",
    sleepWindowInMilliseconds:"hystrix.command.%s.circuitBreaker.sleepWindowInMilliseconds",
    timeoutInMilliseconds:"hystrix.command.%s.execution.isolation.thread.timeoutInMilliseconds",
}

const reverserealKey = {
    "hystrix.threadpool.%s.coreSize":"coresize",
    "hystrix.command.%s.circuitBreaker.requestVolumeThreshold":"requestVolumeThreshold",
    "hystrix.command.%s.circuitBreaker.errorThresholdPercentage":"errorThresholdPercentage",
    "hystrix.command.%s.circuitBreaker.sleepWindowInMilliseconds":"sleepWindowInMilliseconds",
    "hystrix.command.%s.execution.isolation.thread.timeoutInMilliseconds":"timeoutInMilliseconds",
}

const  rules = {
    appcode: [
        { required: true, message: '请选择应用编码' , trigger: 'blur' },
    ],
    authappcode:[
        { required: true, message: '请选择授权应用编码' , trigger: 'blur' },
    ],
    authflag:[
        { required: true, message: '请选择授权标识'},
    ],
    domain:[
        { required: true, message: '请选择领域' },
    ],
};
const m_title = {
    'addriskconfig':'新增服务流控配置',
    'editriskconfig':'编辑服务流控配置',
    'detailriskconfig':'编辑服务流控配置',
};

const domainName = {
    '001':'前台',
    '002':'中台',
    '003':'开放',
    '004':'基础',

};

export default {
    data() {
        return {
            dynaimacState:{
                isShow:false,
            },
            type:'',
            c_title:'',
            domainName,
            appData:{},
            configData:{},
            labelCol: { span: 8 },
            wrapperCol: { span: 14 },
            rules,
            readonlyed:'readonly',
            confirmLoading: false,
            formItemLayout:'horizontal',
            is_vue_task : true,
            is_app_auth:false,
            disabled: this.$route.params.action == "orgdetail" ? true : false,
            modalState:{//选择app弹框
                isShow:false,
                rowsType:'radio', // or 'checkbox'，单选或多选
                selectkeys:[]
            },
            tLoading:false,
            dynamicConfig:[
            ]
        };
    },

    methods: {
        add(){
            this.dynaimacState.isShow = true;
        },
        remove(k){
            console.log(k);
            this.dynamicConfig = this.dynamicConfig.filter((p_item) => {
                return p_item.name != k.name
            })
        },
        onNewConfig(v){
            if(v){
                let filterList = this.dynamicConfig.filter((p_item) => {
                    return p_item.name == v.name
                })

                if(filterList.length > 0 || defaultConfig[v.name]){
                    this.message.error("已存在相同的配置名");
                }
                else{
                    this.dynamicConfig.push({...v})
                }
            }
            this.dynaimacState.isShow = false

        },
        handleOk(){
            let that = this;
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    const { params } = that.$route;
                    let dynamicResult = {};
                    for (let index = 0; index < that.dynamicConfig.length; index++) {
                        const element = that.dynamicConfig[index];
                        if(element.value == null || element.value == ""){
                            that.message.error("动态配置项的值不能为空");
                            return;
                        }
                        dynamicResult[element.name] = element.value + ""
                    }
                    let tempConfigList = {};
                    let tempSource = {...that.configData};
                    for (let key in tempSource) {
                        let element = tempSource[key];
                        let testExite = defaultConfig[key];
                        //配置项必须是默认配置不是动态配置，且不能为空
                        if (testExite != undefined && element) {
                            //替换key为实际值
                            key = realKey[key]
                            tempConfigList[key] = element + ""
                        }
                    }
                    let resultConfigList = {
                        ...tempConfigList,
                        ...dynamicResult
                    }
                    console.log(resultConfigList)
                    let c_params = {
                        appcode:that.appData.appcode,
                        authappcode:that.appData.authappcode,
                        authflag:that.appData.authflag,
                        domain:that.appData.domain,
                        servicekey:that.appData.servicekey,
                        serviceconfig:that.appData.serviceconfig,
                        isoverall:that.appData.isoverall,
                        riskconfig: JSON.stringify(resultConfigList),
                        urlparams:false
                    }

                    if(params.action == 'editriskconfig' || params.action == 'editappriskconfig'){
                        c_params.id = that.appData.id;
                        //编辑
                    }
                    let ctype = "servicekey/updateriskconfig";
                    if(params.action == 'addappriskconfig' || params.action == 'editappriskconfig'){
                        ctype = 'servicekey/updateAppriskconfig'
                    }
                    that.$store
                        .dispatch({
                            type: ctype,
                            params: c_params
                        })
                        .then((response) => {
                            if(response.data.success == '1'){
                                that.handleCancel();
                                that.confirmLoading = false;
                            }
                        });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });

        },
        handleoverallchange(e){
            if(e.target.value == 1){
                this.appData.authappcode = ''
            }
            this.appData.isoverall = e.target.value
        },
        handleSelectAppcode(){
            this.modalState.rowsType = 'radio';
            this.modalState.selectkeys = this.appData.authappcode ? [this.appData.authappcode] : [];
            this.modalState.filterAppcode = this.appData.appcode;
            this.modalState.flag = 1;
            this.modalState.isShow = true;
        },

        handleSelectAppcode2(){
            this.modalState.rowsType = 'radio';
            this.modalState.flag = 0;
            this.modalState.selectkeys = this.appData.appcode ? [this.appData.appcode] : [];
            this.modalState.filterAppcode = ''
            this.modalState.isShow = true;
        },

        handleCancel() {
            this.resetForm();
            this.$router.back(-1);
        },
        resetForm() {
            this.$refs.ruleForm.resetFields();
        },
        onAppselecterHide(result){
            if(result == undefined){
                this.modalState.isShow = false;
                return;
            }
            if(this.modalState.rowsType == 'radio'){
                const { params } = this.$route;
                if(params.action == 'addappriskconfig'){
                    this.appData.appcode = result.length > 0 ? result[0].appcode : ''
                }
                else{
                    this.appData.authappcode = result.length > 0 ? result[0].appcode : ''
                }
            }
            this.modalState.isShow = false;
        },
    },
    computed: {

    },
    components:{
        AppSelecter,
        ConfigModal
    },
    mounted(){
        const { query, params } = this.$route;
        let that = this;
        that.type = params.action;
        that.c_title = m_title[params.action];
        let ctype = "servicekey/queryriskconfiglist";
        if(params.action == 'addappriskconfig' || params.action == 'editappriskconfig'){
            ctype = 'servicekey/detailAppriskconfig'
        }
        if (params.action != "addriskconfig" && params.action != 'addappriskconfig') {
            that.$store.dispatch({
                type: ctype,
                params:query
            }).then((res)=>{
                console.log(res);
                that.tLoading = false;
                let result = res.data.data;
                if(result.length > 0){
                    that.appData = result[0];
                    let jsonData = JSON.parse(that.appData.riskconfig);
                    //替换实际值为磐石绑定字段
                    let tempJson = {};
                    for(var item in jsonData ){
                        let testkey = reverserealKey[item];
                        if(testkey){
                            tempJson[testkey] = jsonData[item]
                        }
                        else{
                            tempJson[item] = jsonData[item];
                        }
                    }
                    that.configData  = tempJson;
                    for(var item_ in tempJson){
                        if(!defaultConfig[item_]){
                            let tempItem = {};
                            tempItem.name = item_;
                            tempItem.value = tempJson[item_];
                            that.dynamicConfig.push(tempItem)
                        }

                    }
                }

            })
        }
        else{
            that.appData = {
                id:'',
                servicekey:query.servicekey,
                serviceconfig:query.serviceconfig,
                appcode:query.appcode,
                authappcode:'',
                authflag:'1',
                isoverall:'0',
                domain:query.domain,
                riskconfig:''
            }
            that.configData = defaultConfig;
            this.dynamicConfig = [];
        }
        that.is_vue_task = params.action != 'detailapp'
        that.is_app_auth = params.action == 'addappriskconfig' || params.action == 'editappriskconfig'
    }
};
</script>

<style scoped>
.dynamic-delete-button {
  cursor: pointer;
  position: relative;
  top: 4px;
  left: 10px;
  font-size: 24px;
  color: #999;
  transition: all 0.3s;
}
.dynamic-delete-button:hover {
  color: #777;
}
</style>
